export const GET_HISTORY=`{
  orderHistories(
    first: $first
    ?skip: $skip
    ?order
    ?where: {
    taker ?eq@ \"$taker\" ?eq|
    orderType:{in:[1,2,3,4,7]}
    $timestamp| 
    }
  ) {
    ?nodes{
    amount
      costPrice
      direction
      name
      price
      orderType
      taker
      token
      tradingFee
      orderID
      id
      timestamp

    ?nodes}
  }
}`

export const GET_HISTORY_ALL_SELL=`{
  orderHistories(
    first: $first
    ?skip: $skip
    ?order
    ?where: {
    taker:{in:[$allTakers]}
    orderType:{in:[1,2,3,4]}
    }
  ) {
    ?nodes{
    amount
      costPrice
      direction
      name
      price
      orderType
      taker
      token
      tradingFee
      orderID
      id
      timestamp

    ?nodes}
  }
}`

export const GET_HISTORY3=`{
  orders(
    first: $first
    ?skip: $skip
    ?order
    ?where: {
    taker ?eq@ \"$taker\" ?eq|
    $openTime| 
    }
  ) {
    ?nodes{
    amount
    closeBlockNumber
    closePrice
    closeTimestamp
    fundingFee
    id
    inviter
    isBuy
    maker
    makerMaintenanceMargin
    makerMargin
    movedProfit
    movedToPubPool
    name
    openBlockNumber
    openPrice
    openTimestamp
    positionProfit
    status
    taker
    token
    tradingFee
    usedPubPool

    ?nodes}
  }
}`

export const GET_HISTORY2=`{
  orders(
    first: $first
    ?skip: $skip
    ?order
   
  ) {
    ?nodes{
    amount
    closeBlockNumber
    closePrice
    closeTimestamp
    fundingFee
    id
    inviter
    isBuy
    maker
    makerMaintenanceMargin
    makerMargin
    movedProfit
    movedToPubPool
    name
    openBlockNumber
    openPrice
    openTimestamp
    positionProfit
    status
    taker
    token
    tradingFee
    usedPubPool

    ?nodes}
  }
}`

export const TRANS_LOG=`
{
  transformTokens(
    first: $first
    ?skip: $skip
    ?order
    ?where: {
    user ?eq@ \"$user\" ?eq|
    trader ?eq@ \"$trader\" ?eq|
    status:{in:[\"1\",\"2\",\"3\"]}
    }
  ) {
    ?nodes{
    
    id,
    user,
    token,
    amount,
    trader,
    isDeposit,
    blockNumber,
    blockTimestamp,
    transactionHash
    share
    status
    time
    orderId
    ?nodes}
  }
}
`

export const TRANS_LOG2=`
{
  transformTokens(
    first: $first
    ?skip: $skip
    ?order
    ?where: {
    trader ?eq@ \"$trader\" ?eq|
    status:{in:[\"1\",\"2\",\"3\"]}
    }
  ) {
    ?nodes{
   
    id,
    user,
    token,
    amount,
    trader,
    isDeposit,
    blockNumber,
    blockTimestamp,
    transactionHash
    share
    status
    time
    orderId
    ?nodes}
  }
}
`

export const GET_PROFIT_COUNT=`
{
  orders(filter: {positionProfit: {equalTo: "0"},
    taker ?eq@ \"$taker\" ?eq|
  }) {
    totalCount
  }
}
`

export const GET_TOTAL_COUNT=`
    {
  orderHistories(filter: {
    taker ?eq@ \"$taker\" ?eq|
  }) {
    totalCount
  }
}
`
export const GET_DIS_PROFIT=`{
  profitsDistributeds(
    first: $first
    ?skip: $skip
    ?order
    ?where: {
    contract:{equalTo:\"$contract\"}
    }
  ) {
    ?nodes{
      contract
      time
      paidDistribute
      token
      trader
      transactionHash
      unpaidDistribute
    ?nodes}
  }
}`


export const GET_LIMIT_ORDERS=`{
        limitOrders(
          first: $first,
          ?skip:$skip
          orderBy: START_TIME_DESC,
          filter: {
            taker: {equalTo: "$taker"},
            state: {greaterThan:1}
          }
        ){
          nodes {
      name
      taker
      token
      orderType
      offset
      amount
      blockNumber
      blockTimestamp
      margin
      orderAddress
      orderID
      rewardGas
      startTime
      state
      targetPrice
      tradingFee
      direct
          }
        }
      }`
